export { FBRef };
var FBRef;
(function (FBRef) {
    FBRef["Records_ER"] = "bills";
    FBRef["Records_ER_A"] = "anzahlungen";
    FBRef["Records_Deb"] = "billsDeb";
    FBRef["Records_FE"] = "bills_fe";
    FBRef["Records_LA"] = "bills_la";
    FBRef["Records_KB"] = "receipts";
    FBRef["Records_Bank"] = "receiptsBank";
    FBRef["Records_Pos"] = "recordsPos";
    FBRef["RecordsLogs_ER"] = "bills_logs";
    FBRef["RecordsLogs_ER_A"] = "anzahlungen_logs";
    FBRef["RecordsLogs_Deb"] = "billsDeb_logs";
    FBRef["RecordsLogs_FE"] = "bills_fe_logs";
    FBRef["RecordsLogs_LA"] = "bills_la_logs";
    FBRef["RecordsLogs_KB"] = "receipts_logs";
    FBRef["RecordsLogs_Bank"] = "receiptsBank_logs";
    FBRef["RecordsLogs_Pos"] = "recordsPos_logs";
    FBRef["Categories"] = "categories";
    FBRef["ProductMembers"] = "companyProductMembers";
    FBRef["Subscriptions"] = "companySubscriptions";
    FBRef["Contacts"] = "contacts";
    FBRef["Creditors"] = "creditors";
    FBRef["Debitors"] = "debitors";
    FBRef["Payments"] = "payments";
    FBRef["Tags"] = "tags";
    FBRef["UsersSessions"] = "usersSessions";
    FBRef["Settings"] = "settings";
    FBRef["Documents"] = "documents";
    FBRef["Banks"] = "banks";
    FBRef["Invoices"] = "invoices";
    FBRef["Templates"] = "templates";
    FBRef["RecordTextTemplates"] = "recordTextTemplates";
})(FBRef || (FBRef = {}));
//# sourceMappingURL=Refs.js.map